import * as SDK from '@replai-platform/sdk';
import { QueryFunction, useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import * as provider from '../../api/provider';

const getTagCsvReport = async (requestParams: SDK.GetTagsCsvReportRequest) => {
  const res = await provider.getJson<object, SDK.GetTagsCsvReportResponse>(
    `${SDK.BASE_URL()}/tags/csv?${SDK.convertRequestToQueryParams(requestParams)}`
  );
  return res;
};

const KEY = 'tag-csv-report';
type Key = typeof KEY;

type Result = SDK.GetTagsCsvReportResponse;
type QueryKey = [Key, SDK.GetTagsCsvReportRequest];

type QueryOptions<R = Result> = UseQueryOptions<Result, unknown, R, QueryKey>;
type QueryResult<R = Result> = UseQueryResult<R>;

const queryFn: QueryFunction<Result, QueryKey> = ({ queryKey: [, requestParams] }) => getTagCsvReport(requestParams);

// This is exported so we can use useQueries
export function getTagCsvReportQueryOptions<R = Result>(
  requestParams: SDK.GetTagsCsvReportRequest,
  options?: QueryOptions<R>
): QueryOptions<R> {
  return {
    queryKey: [KEY, requestParams],
    queryFn,
    ...options,
  };
}

export default function useTagCsvReport<R = Result>(
  requestParams: SDK.GetTagsCsvReportRequest,
  options?: QueryOptions<R>
): QueryResult<R> {
  return useQuery(getTagCsvReportQueryOptions(requestParams, options));
}
